module.exports = __webpack_public_path__ + "static/media/Image_36.7e19cfd3.png";